import ApiService from './api.service'

const IncomeService = {
  pdfListIncome: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/ingresos/list-pdf',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  excelListIncome: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/ingresos/list-excel',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  storeIncome: async function(data) {
    try {
      const response = await ApiService.post('/ingresos/agencia', data)
      return response
    } catch (error) {
      throw error
    }
  },

  editIncome: async function(id) {
    try {
      const response = await ApiService.get(`ingresos/${id}/edit`)
      return response
    } catch (error) {
      throw error
    }
  },

  updateIncome: async function(id, data) {
    try {
      const response = await ApiService.put(`ingresos/${id}`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  cancelIncome: async function(id) {
    try {
      const response = await ApiService.delete(`ingresos/${id}`)
      return response
    } catch (error) {
      throw error
    }
  },

  showIncome: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  aprovedIncome: async function(data) {
    try {
      const response = await ApiService.post('/ingresos/aprobar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  executedIncome: async function(data) {
    try {
      const response = await ApiService.post('/ingresos/ejecutar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  getListCubi: async function(id) {
    try {
      const options = {
        method: 'get',
        url: `ingresos/cubi/${id}`,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  downloadIncome: async function(id, type) {
    try {
      const options = {
        method: 'get',
        url: `ingresos/descarga/${id}`,
        responseType: 'arraybuffer',
        params: {
          type: type
        }
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },
}

export default IncomeService